import React from 'react';
import { Table } from 'react-bootstrap';
import Row from './components/Row';

const BidderSourcesCountryTable = ({ sources, onRemove, onUpdate, onDuplicate, onSort }) => {
    const rows = sources.map((source, index) => <Row key={index} source={source} onUpdate={onUpdate} onDuplicate={onDuplicate} onRemove={onRemove}/>);

    return (
        <Table bordered responsive style={{ textAlign: 'center', verticalAlign: 'middle' }}>
            <thead>
                <tr>
                    <th onClick={() => onSort('name')}>Name</th>
                    <th>Type</th>
                    <th>Countries</th>
                    <th>Action</th>
                </tr>
            </thead>
            <tbody>
                {rows}
            </tbody>
        </Table>
    )
};

export default BidderSourcesCountryTable;


// WEBPACK FOOTER //
// ./src/scenes/BidderSourcesCountry/components/Table/index.js